import { OverlayToaster, Position, Intent, IconName } from "@blueprintjs/core";
import { ReactNode } from "react";

const AppToaster = OverlayToaster.create({
  position: Position.TOP_RIGHT,
});


const getTimeout = (timeout: number | undefined, fallback: number) =>
  typeof timeout === "number" ? timeout : fallback;

const isError = (x: any): x is Error => x instanceof Error;

const showToast = (
  message: ReactNode,
  intent: Intent,
  icon: IconName,
  timeout: number
) => {
  AppToaster.show({ message, intent, icon, timeout });
};

const success = (message: ReactNode, timeout?: number) =>
  showToast(message, "success", "thumbs-up", getTimeout(timeout, 2500));

const error = (err: ReactNode | Error, timeout?: number) => {
  const msg = isError(err) ? err.message : err;
  showToast(msg, "danger", "thumbs-down", getTimeout(timeout, 5000));
};

const info = (message: ReactNode, timeout?: number) =>
  showToast(message, "none", "info-sign", getTimeout(timeout, 5000));

const clearToast = () => AppToaster.clear();

export default {
  success,
  error,
  message: info,
  clearToast,
};
